var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-progress-circular',{attrs:{"value":_vm.compValue,"rotate":-90,"size":_vm.size,"width":_vm.width,"color":_vm.color,"large":""}},[_vm._v(" "+_vm._s(_vm.compValue)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }